var commerce = {};
module['exports'] = commerce;
commerce.color = require("./color");
commerce.department = require("./department");
commerce.product_name = require("./product_name");



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/az/commerce/index.js
// module id = 2359
// module chunks = 1609